export const PUBLIC_LEGAL_DOCUMENTS = [
  { path: "/terms-of-service", label: "Terms of Service" },
  { path: "/privacy-policy", label: "Privacy Policy" },
];
